export const generateCreditCardLogoPath = (brand?: string): string => {
  if (!brand) return ''

  // パスカルケースのブランド名の形式に正規化するマッパー
  // ブランドが増えたらここに追加する
  const brandMap: Record<string, string> = {
    americanexpress: 'AmericanExpress',
    amex: 'AmericanExpress',
    jcb: 'JCB',
    mastercard: 'MasterCard',
    visa: 'Visa',
  }

  // 入力値を正規化（小文字化＆スペース・アンダースコア削除）
  const normalizedBrand = brand.toLowerCase().replace(/[\s_]+/g, '')

  // 事前定義されたブランドならマッピング、それ以外はそのまま
  const pascalCaseBrand = brandMap[normalizedBrand] || brand

  return `images/creditcard/${pascalCaseBrand.replace(/\s+/g, '')}_logo.png`
}
